const users = [
    {
        title:'amit',
        desc: 'can talk to me'
    },
    {
        title:'Olive Yew',
        desc: 'can talk to me'
    },
    {
        title:'Aida Bugg',
        desc: 'can talk to me'
    }
]
export default users